import { CONST } from "../../CONST";
import { BurgerScene } from "../../scenes/BurgerScene";

interface CountdownConfig{
    scene: BurgerScene,
    position: {x: number, y: number},
    onComplete: ()=>void,
}   

const CONF = {
    text: {size: 35,
        colorString: "#F76B68",
        colorNum: 0xF76B68,
    },
    depth: 65,
}

export class Countdown extends Phaser.GameObjects.Container{
    public config: CountdownConfig;

    private text !: Phaser.GameObjects.Text;
    private bg !: Phaser.GameObjects.Image;
    private radialMask !: Phaser.GameObjects.Graphics;

    private currentDuration: number;
    private remainingDuration: number;

    public isCountingDown: boolean;

   constructor(config: CountdownConfig){
       super(config.scene, config.position.x, config.position.y);
        this.config = config;

        this.currentDuration = 1000;
        this.remainingDuration = 0;
        this.isCountingDown = false;

        this.createChildren();
        this.setDepth(CONF.depth)

        config.scene.add.existing(this);
        config.scene.events.on('update', this.onUpdate, this);
    }

    public start(duration: number){
        this.currentDuration = duration;

        this.remainingDuration = duration;
        this.isCountingDown = true;
        return this;
    }

    public pause(){
       this.isCountingDown = false;
    }

    public restart(duration: number, startDelay: number){
        this.isCountingDown = false;

        var countdownPercentage = this.getRemainingTimeShare();
        this.currentDuration = duration;

        this.remainingDuration = this.currentDuration * countdownPercentage; //For smoother animation when duration changes

        this.config.scene.tweens.addCounter({
            from: this.remainingDuration,
            to: this.currentDuration,
            ease: "Quad.easeInOut",
            duration: startDelay/2,
            onUpdate: function(tween){
                var value = Math.floor(tween.getValue());
                this.remainingDuration = value;
                this.updateDisplay();
            },
            onUpdateScope: this,
        });

        setTimeout( () => {
            this.start(duration);
        }, startDelay);
    }

    private createChildren(){
        this.bg = this.config.scene.add.image(0, 0, CONST.BURGER.TIMER);

        //TOOD: decide text vs bitmaptext
        this.text = this.config.scene.add.text(-12, -13, "0:00", 
            {fontFamily: 'bloggerSans', fontSize: CONF.text.size, color: CONF.text.colorString, align: 'center'}); 

        this.radialMask = this.config.scene.add.graphics();
        this.radialMask.setPosition(-40.5, 3.5);
        this.radialMask.setAngle(-90).setScale(1, -1);

        let white = this.config.scene.add.image(-41.4, 1.6, CONST.BURGER.TIMER_CIRCLE).setScale(0.94, 1);

        this.add([this.bg, this.text, white, this.radialMask]);
    }

    private onUpdate(time: number, delta: number){
        if (!this.isCountingDown){
            return;
        }

        this.remainingDuration -= delta;
        if (this.remainingDuration < 0){
            this.remainingDuration = 0;
            this.config.onComplete();
            this.pause();
        }

        this.updateDisplay();
    }

    updateDisplay(){
        var remainingPercentage = this.getRemainingTimeShare();

        this.text.text = this.formatTimeText(this.remainingDuration);
        this.updateMask(remainingPercentage);
    }

    updateMask(percentage: number){
        let width = 22.5;
        let angle = Phaser.Math.DegToRad(360*percentage);

        this.radialMask.clear();
        this.radialMask.lineStyle(width, CONF.text.colorNum, 1);
        this.radialMask.beginPath();

        this.radialMask.arc(0, 0, width/2, 0, angle, false);
        this.radialMask.strokePath();
        this.radialMask.closePath();
    }

    formatTimeText(ms: number){
       let seconds = Math.floor((ms / 1000) % 60);
       let  minutes = Math.floor((ms / (1000 * 60)) % 60);
        
       return minutes + ":" + ((seconds < 10) ? "0" + seconds : seconds);
    }

    private getRemainingTimeShare(){
        return this.remainingDuration / this.currentDuration;
    }

    public getElapsedTime(){
        return this.currentDuration - this.remainingDuration;
    }

    public getTotalTime(){
        return this.currentDuration;
    }
}